import * as React from "react";
import { MediaQuery } from "react-responsive";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { Select } from "../select/select.mjs";
import { Slider } from "../slider/slider.mjs";
import { ThemeContext } from "../../helpers/theme-provider/theme-provider.mjs";
const ResponsiveSlider = (props) => {
  return /* @__PURE__ */ React.createElement(
    PropsChecker,
    {
      componentProps: props,
      componentName: "ResponsiveSlider",
      defaultValueName: "defaultValue",
      valueName: "value",
      onChangeNames: "onChange",
      isComponentDisabled: props.disabled
    },
    /* @__PURE__ */ React.createElement(ResponsiveSliderInner, { ...props })
  );
};
const _ResponsiveSliderInner = class _ResponsiveSliderInner extends React.Component {
  constructor(props) {
    super(props);
    this.onSelectChange = (newValue) => {
      if (typeof this.props.value === "undefined") {
        this.setState({
          value: newValue
        });
      }
      if (this.props.onChange) {
        this.props.onChange(newValue);
      }
    };
    this.onSliderChange = (newValue) => {
      const sliderValue = newValue;
      const newCurrentOption = this.props.options.find(({ value }) => parseFloat(value) === sliderValue);
      if (newCurrentOption && this.state.value !== newCurrentOption.value && typeof this.props.value === "undefined") {
        this.setState({
          value: newCurrentOption.value
        });
      }
      if (this.props.onChange && newCurrentOption) {
        this.props.onChange(newCurrentOption.value);
      }
    };
    this.state = {
      isMounted: false,
      value: this.props.defaultValue || null
    };
  }
  componentDidMount() {
    this.setState({
      isMounted: true
    });
  }
  renderSelect() {
    return /* @__PURE__ */ React.createElement(
      Select,
      {
        className: this.props.className,
        id: this.props.id,
        label: this.props.label,
        options: this.props.options,
        onChange: this.onSelectChange,
        value: typeof this.props.value !== "undefined" ? this.props.value : this.state.value,
        simpleValue: true,
        disabled: this.props.disabled
      }
    );
  }
  getSliderPips(options) {
    return options.map((option) => {
      return {
        disabled: option.isDisabled,
        label: option.children || option.label,
        showAsterisk: option.showAsterisk,
        value: parseFloat(option.value)
      };
    });
  }
  getCurrentItem(options, stateOption) {
    let currentItemValue = this.getMinRangeValue(this.props.options);
    const newCurrentOption = options.find(({ value }) => value === stateOption);
    if (newCurrentOption && newCurrentOption.value === stateOption) {
      currentItemValue = parseFloat(newCurrentOption.value);
    }
    return currentItemValue;
  }
  getMinRangeValue(options) {
    return options.reduce((min, { value }) => parseFloat(value) < min ? parseFloat(value) : min, parseFloat(options[0].value));
  }
  getMaxRangeValue(options) {
    return options.reduce((max, { value }) => parseFloat(value) > max ? parseFloat(value) : max, parseFloat(options[0].value));
  }
  renderSlider() {
    return /* @__PURE__ */ React.createElement(
      Slider,
      {
        id: this.props.id,
        label: this.props.label,
        className: this.props.className,
        start: this.getCurrentItem(this.props.options, typeof this.props.value !== "undefined" ? this.props.value : this.state.value),
        range: {
          min: this.getMinRangeValue(this.props.options),
          max: this.getMaxRangeValue(this.props.options)
        },
        step: this.props.step,
        unit: this.props.unit,
        pips: this.getSliderPips(this.props.options),
        onChange: this.onSliderChange,
        direction: this.props.direction,
        disabled: this.props.disabled
      }
    );
  }
  renderDynamicLayout() {
    return /* @__PURE__ */ React.createElement(MediaQuery, { minWidth: this.context.media.width.sm.min }, (matches) => matches ? this.renderSlider() : this.renderSelect());
  }
  render() {
    return this.state.isMounted ? this.renderDynamicLayout() : this.renderSelect();
  }
};
_ResponsiveSliderInner.contextType = ThemeContext;
let ResponsiveSliderInner = _ResponsiveSliderInner;
export {
  ResponsiveSlider,
  ResponsiveSliderInner
};
